import { Component, OnInit } from '@angular/core';
import { BaseIcon } from '../base-icon';

@Component({
	selector: 'app-icon-people',
	templateUrl: './icon-people.component.html',
	styleUrls: ['./icon-people.component.scss'],
})
export class IconPeopleComponent extends BaseIcon implements OnInit {
	constructor() {
		super();
	}

	ngOnInit() {}
}
